import "./index.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import {
  faBars,
  faCheck,
  faEdit,
  faMicrophone,
  faPaw,
  faStop,
  faTimes,
  faWeight,
} from "@fortawesome/free-solid-svg-icons";
import * as Sentry from "@sentry/react";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import mixpanel from "mixpanel-browser";
import ReactDOM from "react-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Providers from "./components/index/providers";
import App from "./components/layout/App";
import { getConfig } from "./config";
import { IGNORED_AUTH_ERRORS } from "./constants.js";
import { isMCloudIFrame, setMCloudEmbedded } from "./utils";

/** LOGOUT PREVIOUS USER IF EMBEDDED */
if (isMCloudIFrame()) {
  localStorage.clear();
  setMCloudEmbedded();
  window.location.href = `${
    getConfig().flask
  }/sso/mvp/logout?origin=${window.location.origin}`;
}

/** BEGIN SENTRY CONFIG */
if (getConfig().sentry.enabled) {
  Sentry.init({
    dsn: getConfig().sentry.dsn,
    environment: getConfig().environmentName,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: getConfig().sentry.tracesSampleRate,
    ignoreErrors: IGNORED_AUTH_ERRORS,
  });
  //Set the web app version
  Sentry.setTag("web_app_version", process.env.REACT_APP_VERSION);
}
/** END SENTRY CONFIG */

mixpanel.init(getConfig().mixpanel.id, {
  debug: getConfig().mixpanel.debug,
  cookie_domain: getConfig().mixpanel.cookie_domain,
  cross_subdomain_cookie: getConfig().mixpanel.cross_subdomain_cookie,
});

// Disable MixPanel if not enabled in config
if (!getConfig().mixpanel.enabled) {
  mixpanel.disable();
}

mixpanel.register({
  "Web App Version": process.env.REACT_APP_VERSION,
});

library.add(
  faCopy,
  faBars,
  faMicrophone,
  faStop,
  faPaw,
  faEdit,
  faCheck,
  faTimes,
  faWeight,
);

const contextClass = {
  success: "bg-green-600",
  error: "bg-red-600",
  info: "bg-gray-600",
  warning: "bg-yellow-500",
  default: "bg-indigo-600",
  dark: "bg-gray-600 text-gray-100",
};

(async () => {
  const userUuid = localStorage.getItem("root_logged_in_user_uuid");
  const LDProvider = await asyncWithLDProvider({
    clientSideID: getConfig().launchdarkly.client_key,
    context: {
      key: userUuid ? `user-uuid-${userUuid}` : "anonymous-user",
    },
  });
  ReactDOM.render(
    <LDProvider>
      <Providers>
        <App />
        <ToastContainer
          className={"pb-14"}
          toastClassName={({ type }) =>
            contextClass[type || "default"] +
            " my-2 relative flex p-1 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer"
          }
          bodyClassName={() =>
            "text-sm font-white font-med block p-3"
          }
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
        />
      </Providers>
    </LDProvider>,
    document.getElementById("root"),
  );
})();
